import { useState, useCallback } from 'react';
import { facturacionAPI } from '../services/facturacionAPI';

export const useFacturacion = () => {
  const [loading, setLoading] = useState(false);
  const [consultas, setConsultas] = useState([]);
  const [practicas, setPracticas] = useState([]);
  const [totales, setTotales] = useState({
    consultasSubtotal: 0,
    consultasCopago: 0,
    consultasTotal: 0,
    practicasSubtotal: 0,
    practicasCopago: 0,
    practicasTotal: 0
  });

  const cargarFacturacion = useCallback(async (idObraSocial, mes, anio) => {
    setLoading(true);
    try {
      const fechaDesde = new Date(anio, mes - 1, 1);
      const data = await facturacionAPI.getFacturacionObrasSociales(idObraSocial, fechaDesde.toISOString());
      
      const practicasMapped = data.map((item) => ({
        ...item,
        selected: item.facturable !== false,
        codigo: item.codigoPractica,
        grav: item.gravado,
        importe: item.importe || 0,
        medioIva: item.medioIva || 0,
        conCopago: item.conCopago || 0,
        f_Estudio: item.f_Estudio,
        apellido: item.apellido,
        nombre: item.nombre,
        dni: item.dni,
        practica: item.practica,
        forma: item.forma,
        presentacion: item.presentacion,
        nroFactura: item.nroFactura,
        nroAfiliado: item.nroAfiliado
      }));

      practicasMapped.sort((a, b) => {
        const fechaA = a.f_Estudio ? new Date(a.f_Estudio) : new Date(0);
        const fechaB = b.f_Estudio ? new Date(b.f_Estudio) : new Date(0);
        return fechaA - fechaB;
      });

      const practicasData = practicasMapped.map((item, index) => ({
        ...item,
        rowNumber: index + 1
      }));
      
      setConsultas([]);
      setPracticas(practicasData);
      calcularTotales([], practicasData);
    } catch (error) {
      console.error('Error al cargar facturación:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const calcularTotales = (consultasData, practicasData) => {
    const calc = (data) => {
      let subtotal = 0, copago = 0, total = 0;
      data.forEach(item => {
        if (!item.selected) return;
        const importe = parseFloat(item.importe) || 0;
        const medioIva = parseFloat(item.medioIva) || 0;
        const conCopago = parseFloat(item.conCopago) || 0;
        subtotal += importe;
        copago += conCopago;
        total += (importe + medioIva - conCopago);
      });
      return [subtotal, copago, total];
    };

    const cRes = calc(consultasData);
    const pRes = calc(practicasData);

    setTotales({
      consultasSubtotal: cRes[0], consultasCopago: cRes[1], consultasTotal: cRes[2],
      practicasSubtotal: pRes[0], practicasCopago: pRes[1], practicasTotal: pRes[2]
    });
  };

  const toggleSeleccion = useCallback(async (tipo, index) => {
    const item = practicas[index];
    const nuevoEstado = !item.selected;
    const nuevas = [...practicas];
    nuevas[index].selected = nuevoEstado;
    setPracticas(nuevas);
    calcularTotales(consultas, nuevas);
    await facturacionAPI.toggleFacturable(item.idTurno, nuevoEstado);
    return { apellido: item.apellido, nombre: item.nombre, facturable: nuevoEstado };
  }, [consultas, practicas]);

  const toggleAll = useCallback((seleccionar) => {
    const nuevas = practicas.map(p => ({ ...p, selected: seleccionar }));
    setPracticas(nuevas);
    calcularTotales(consultas, nuevas);
  }, [consultas, practicas]);

  return {
    loading,
    consultas,
    practicas,
    totales,
    cargarFacturacion,
    toggleSeleccion,
    toggleAll
  };
};
